import { useContext } from "react";
import { BookingSetStateContext, BookingStateContext } from "store/store-context";

export const useBookingStateContext = () => useContext(BookingStateContext);
export const useBookingActionsContext = () => useContext(BookingSetStateContext);
